export const css = {
    oneaction: '_1tL7Je8B',
    ' _key': 'apic-theme/apic/quiz-widgets/singlestep'
};
export default css;
